import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Login from '@/views/Login.vue'
import Timesheet from '@/views/Timesheet/Timesheet.vue'
import TimesheetMonthlyReport from '@/views/Timesheet/TimesheetSubpages/TimesheetMonthlyReport.vue'
import TimesheetCreateJob from '@/views/Timesheet/TimesheetSubpages/TimesheetCreateJob.vue'

import Contacts from '@/views/Sales/Contacts.vue'
import ContactsEdit from '@/views/Sales/ContactsSubpages/ContactsEdit.vue'
import ContactsSearch from '@/views/Sales/ContactsSubpages/ContactsSearch.vue'

import Offers from '@/views/Sales/Offers.vue'
import Schoolview from '@/views/Sales/OffersSubpages/OffersSchoolview.vue'
import OffersCreateOffer from '@/views/Sales/OffersSubpages/OffersCreateOffer.vue'
import CalculatePrice from '@/views/Sales/OffersSubpages/OffersCalculatePrice.vue'
import OffersSearch from '@/views/Sales/OffersSubpages/OffersSearch.vue'
import SelectContactsView from '@/views/Sales/OffersSubpages/OffersSelectContactView.vue'

import Tiptel from '@/views/External/Tiptel.vue'

import VISA from '@/views/Financial_services/VISA.vue'
import VISAReceipts from '@/views/Financial_services/VISASubpages//VISAReceipts.vue'
import VISAArchive from '@/views/Financial_services/VISASubpages/VISAArchive.vue'

import Admin from '@/views/Admin/Admin.vue'

import Nice from '@/views/Nice.vue'

// Media player imports
import Media from '@/views/Media/Media.vue'
import VideoPlayer from '@/views/Media/VideoPlayer.vue'

const routes: Array<RouteRecordRaw> = [
    ////////////////////////////////////////////////
    ///////////////// TIMESHEET ////////////////////
    ////////////////////////////////////////////////

    // "TIMESHEET"

    {
        path: '/',
        name: 'login',
        component: Login,
        meta: { hideNavbar: true },
    },
    {
        path: '/timesheet',
        name: 'timesheet',
        component: Timesheet,
    },
    {
        path: '/monthlyreport',
        name: 'TimesheetMonthlyReport',
        component: TimesheetMonthlyReport,
    },
    {
        path: '/createjob',
        name: 'TimesheetCreateJob',
        component: TimesheetCreateJob,
    },

    ////////////////////////////////////////////////
    //////////////////// SALES /////////////////////
    ////////////////////////////////////////////////

    // "CONTACTS"

    {
        path: '/contacts',
        name: 'Contacts',
        component: Contacts,
    },
    {
        path: '/contacts/edit/:id',
        name: 'ContactsEdit',
        component: ContactsEdit,
    },
    {
        path: '/contacts/search',
        name: 'ContactsSearch',
        component: ContactsSearch,
    },

    // "OFFERTEN"

    {
        path: '/offers',
        name: 'Offers',
        component: Offers,
    },
    {
        path: '/offers/selectcontacts',
        name: 'SelectContactsView',
        component: SelectContactsView,
    },
    {
        path: '/offers/schoolview/:id',
        name: 'Schoolview',
        component: Schoolview,
    },
    {
        path: '/offers/createoffer/:id/:offer?',
        name: 'OffersCreateOffer',
        component: OffersCreateOffer,
    },
    {
        path: '/offers/calculateprice/:id/:offer?',
        name: 'CalculatePrice',
        component: CalculatePrice,
    },
    {
        path: '/offers/search/:id',
        name: 'OffersSearch',
        component: OffersSearch,
    },

    ////////////////////////////////////////////////
    ////////////////// EXTERNAL ////////////////////
    ////////////////////////////////////////////////

    // Tiptel

    {
        path: '/tiptel',
        name: 'Tiptel',
        component: Tiptel,
    },

    ////////////////////////////////////////////////
    ///////////// FINANCIAL SERVICES ///////////////
    ////////////////////////////////////////////////

    // FINANCE

    {
        path: '/visa',
        name: 'VISA',
        component: VISA,
    },
    {
        path: '/visa/receipts',
        name: 'VISAReceipts',
        component: VISAReceipts,
    },
    {
        path: '/visa/archive',
        name: 'VISAArchive',
        component: VISAArchive,
    },

    // {
    //     path: '/bills',
    //     name: 'Bills',
    //     component: Bills,
    // },

    ////////////////////////////////////////////////
    /////////////////// ADMIN //////////////////////
    ////////////////////////////////////////////////

    // Admin

    {
        path: '/admin',
        name: 'Admin',
        component: Admin,
    },

    // Nice

    {
        path: '/nice',
        name: 'Nice',
        component: Nice,
    },

    ////////////////////////////////////////////////
    /////////////////// MEDIA //////////////////////
    ////////////////////////////////////////////////

    // Media Player

    {
        path: '/media',
        name: 'Media',
        component: Media,
        children: [
            {
                path: 'player/:id?',
                name: 'VideoPlayer',
                component: VideoPlayer,
            },
        ],
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    // Add scrollBehavior to scroll to top on navigation
    scrollBehavior(to, from, savedPosition) {
        // If the user used the browser's back/forward buttons and a saved position exists
        if (savedPosition) {
            return savedPosition
        }

        // For media player routes, always scroll to top
        if (to.name === 'VideoPlayer' || to.path.includes('/media/player')) {
            return { top: 0, behavior: 'smooth' }
        }

        // Default behavior: scroll to top
        return { top: 0 }
    },
})

export default router
